// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hl-6";
export var emphasizeQuantity = "_hl-3";
export var flatBottomCorners = "_hl-5";
export var productImage = "_hl-0";
export var quantityContainer = "_hl-2";
export var tooltip = "_hl-1";
export var wrapAndEllipsesOverflow = "_hl-4";